// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';

// Import all your modules
import Homepage from './modules/Home';
import AboutUs from './modules/About';
import Awards from './modules/Awards';
import Activities from './modules/Activities';
import ContactUs from './modules/Contact';
import CSR from './modules/CSR';
import Trek from './modules/Trek';
import Donate from './modules/Donate';
import Donate_IOS from './modules/Donate_IOS';
import ForeignDonations from './modules/ForeignDonations';
import FounderStory from './modules/FounderStory';
import Gallery from './modules/Gallery';
import News from './modules/News';
import Correspondence from './modules/Correspondent';
import Impact from './modules/Impact';
import Programs from './modules/Programs';
import Testimonials from './modules/Testimonials';
import VisitorsBook from './modules/VisitorsBook';
import Volunteer from './modules/Volunteer';

function App() {
  return (
    <div className="App">
      
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/home" element={<Homepage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/awards" element={<Awards />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/csr" element={<CSR />} />
        <Route path="/trek" element={<Trek />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/ios_donate" element={<Donate_IOS />} />
        <Route path="/foreign-donations" element={<ForeignDonations />} />
        <Route path="/founder-story" element={<FounderStory />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/news" element={<News />} />
        <Route path="/correspondence" element={<Correspondence />} />
        <Route path="/impact" element={<Impact />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/visitors-book" element={<VisitorsBook />} />
        <Route path="/volunteer" element={<Volunteer />} />
      </Routes>
      
    </div>
  );
}

export default App;